import type { AgentLandingConfig } from "@/components/AgentLanding";
import faqMd from "@/content/faqs/ai-team-buzz.md?raw";
import { Calendar, Megaphone, Repeat, Share2 } from "lucide-react";

export const buzzConfig: AgentLandingConfig = {
    name: "Buzz",
    slug: "buzz",
    accent: "#FB8C3C",
    seo: {
        title: "Buzz — AI Social Media Manager | Pixro AI",
        description:
            "Meet Buzz, Pixro's AI social media manager. He turns finished assets into platform-ready posts — sized, captioned, and scheduled so your feed never goes quiet. Coming soon.",
        keywords: [
            "AI social media manager",
            "AI social content",
            "content scheduling AI",
            "social media automation",
            "AI creative crew",
            "Pixro AI team",
        ],
    },
    hero: {
        headline: "your AI social media manager",
        subcopy:
            "Buzz keeps every channel fed. He turns finished assets into platform-ready posts — sized, captioned, repurposed, and scheduled — so your feed stays active without the daily grind.",
        image: "https://cdn.pixro.ai/26a78526-f26f-408d-8964-5cc1e4f7331e.jpg",
        imageAlt: "Buzz, Pixro's AI social media manager",
    },
    capabilities: {
        heading: "The manager who keeps every channel fed",
        intro: "Buzz is the last mile — packaging the crew's work into channel-native content that ships on schedule.",
        items: [
            {
                title: "Platform formatting",
                body: "Adapts each asset to the exact size and style every platform needs.",
                Icon: Share2,
            },
            {
                title: "Posting cadence",
                body: "Plans a steady schedule so your feed never goes quiet.",
                Icon: Calendar,
            },
            {
                title: "Content repurposing",
                body: "Turns one asset into a week of posts across formats and channels.",
                Icon: Repeat,
            },
            {
                title: "Channel-native packaging",
                body: "Frames every post the way each platform's audience expects.",
                Icon: Megaphone,
            },
        ],
    },
    howItWorks: {
        heading: "From finished asset to a full feed",
        steps: [
            {
                title: "Bring finished assets",
                body: "Hand Buzz the photos, videos, and copy the crew produced.",
            },
            {
                title: "Buzz adapts per platform",
                body: "He resizes, captions, and reframes each asset for its channel.",
            },
            {
                title: "Schedules the drop",
                body: "Buzz plans the cadence so everything posts at the right time.",
            },
            {
                title: "Keeps the feed full",
                body: "Your channels stay active and on-brand without the daily grind.",
            },
        ],
    },
    directs: {
        heading: "Ready-to-post content, everywhere",
        intro: "Buzz packages the crew's output into channel-native posts for every platform.",
        tools: [
            { label: "AI Fashion reels", desc: "Reels formatted for each platform" },
            { label: "UGC videos", desc: "Social-native ad posts" },
            { label: "Product videos", desc: "Feed and story cuts" },
            { label: "Resize", desc: "Every channel size, packaged" },
        ],
    },
    crewSubcopy:
        "Buzz is the last mile — packaging the crew's work into channel-native content that ships on schedule.",
    faqMd,
};
